import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["country", "currency", "employeePrice", "hasEmployeeDiscount", "isOnSale", "listPrice", "localeForCurrency", "salePrice", "renderDiscountAddendum", "renderFullPricePrefix"];
import React from 'react';
import PropTypes from 'prop-types';
import FormattedPrice from './formatted-price';
var FinalPrice = function FinalPrice(_ref) {
  var country = _ref.country,
    currency = _ref.currency,
    employeePrice = _ref.employeePrice,
    hasEmployeeDiscount = _ref.hasEmployeeDiscount,
    isOnSale = _ref.isOnSale,
    listPrice = _ref.listPrice,
    localeForCurrency = _ref.localeForCurrency,
    salePrice = _ref.salePrice,
    renderDiscountAddendum = _ref.renderDiscountAddendum,
    renderFullPricePrefix = _ref.renderFullPricePrefix,
    intlOptions = _objectWithoutProperties(_ref, _excluded);
  if (hasEmployeeDiscount) {
    return /*#__PURE__*/React.createElement(FormattedPrice, _extends({}, intlOptions, {
      country: country,
      currency: currency,
      discountedPrice: employeePrice,
      listPrice: listPrice,
      localeForCurrency: localeForCurrency,
      renderDiscountAddendum: renderDiscountAddendum,
      renderFullPricePrefix: renderFullPricePrefix
    }));
  } else if (isOnSale) {
    return /*#__PURE__*/React.createElement(FormattedPrice, _extends({}, intlOptions, {
      country: country,
      currency: currency,
      discountedPrice: salePrice,
      listPrice: listPrice,
      localeForCurrency: localeForCurrency,
      renderDiscountAddendum: renderDiscountAddendum,
      renderFullPricePrefix: renderFullPricePrefix
    }));
  }
  // Returns list price
  return /*#__PURE__*/React.createElement(FormattedPrice, _extends({}, intlOptions, {
    country: country,
    currency: currency,
    listPrice: listPrice,
    localeForCurrency: localeForCurrency,
    renderDiscountAddendum: renderDiscountAddendum,
    renderFullPricePrefix: renderFullPricePrefix
  }));
};
FinalPrice.propTypes = {
  /**
   * country code, preferred as lowercase. Used for Japan addendum logic.
   */
  country: PropTypes.string,
  /**
   * currency code, preferred in caps
   */
  currency: PropTypes.string,
  /**
   * the employee discount price for a product
   */
  employeePrice: PropTypes.string,
  /**
   * whether the user is eligible for employee discounts
   */
  hasEmployeeDiscount: PropTypes.bool,
  /**
   * whether the item is on sale
   */
  isOnSale: PropTypes.bool,
  /**
   * the listPrice of a product (eg from merch/price/v1)
   */
  listPrice: PropTypes.string,
  /**
   * the locale value from which to format the specified currency
   */
  localeForCurrency: PropTypes.string,
  /**
   * the sale price for a product
   */
  salePrice: PropTypes.string,
  /**
   * Discount addendum for Japan sale price
   */
  renderDiscountAddendum: PropTypes.func,
  /**
   * MRP for india full retail price
   */
  renderFullPricePrefix: PropTypes.func
};
export default /*#__PURE__*/React.memo(FinalPrice);